<template>
  <div class="relative">
    <modal :show.sync="editModal" header-classes="bg-primary p-7" size="lg">
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold"
      >
        Caregiver Saathi
      </h6>
      <div class="mt-5">
        <p class="mt-2 input-title-black">By submitting this form:</p>
        <p class="mt-2 input-title-black">
          1) You let Caregiver Saathi and its partners use this data for
          insights and analytics. You are not flooded with unnecessary
          information, and it enables us to send you more relevant information
          and resources to support you.
        </p>
        <p class="mt-2 input-title-black">
          2) You agree to be contacted with information and future programs,
          events,promotions, pertaining to the areas of interest you have
          specified in this form.
        </p>
      </div>
      <template slot="footer">
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <div class="lg:px-24 md:px-24 px-5 lg:w-3/4 md:3/4">
      <h2 class="fsize35 sm-fsize20 cust-overlap">Get In Touch</h2>
      <p class="fsize18 sm-fsize14 cust-overlap">
        An exceptional curriculum focusing on perspectives,tools and means of
        engagement looking from the lens of a Caregiver
      </p>

      <div class="absolute top-0 left-0 top-42px mob-hidden">
        <img
          src="../../../assets/images/coachnew/Rectangle 16.png"
          alt="bg-polygon"
          class="h-full w-full"
        />
      </div>
      <div class="absolute right-0 mob-hidden">
        <img
          src="../../../assets/images/Polygon 11.svg"
          alt="bg-polygon"
          class="h-full w-full"
        />
      </div>
      <div class="absolute right-0 bottom-0 mob-hidden">
        <img
          src="../../../assets/images/coachnew/Ellipse 22.png"
          alt="bg-polygon"
          class="h-full w-full"
        />
      </div>
    </div>
    <div
      class="col-span-2 bg-primary sm-m1rem md:rounded-3xl lg:mx-24 md:px-12 lg:mt-14 md:mt-8 lg:w-1/2 md:w-8/12 lg:rounded-3xl rounded-xl md:p-8 lg:p-8 p-4 shadow-b-2xl relative trans-zoom-half"
    >
      <div>
        <div>
          <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <b-form
              role="form"
              @submit.prevent="handleSubmit(handleSend)"
              class="lg:px-20 md:px-1 px-4"
            >
              <div class="flex justify-center">
                <p class="font-bold text-white fsize35-20 mb-2">Query form</p>
              </div>
              <div class="pt-6">
                <div class="">
                  <p class="input-title">Name</p>
                  <base-input
                    v-model="fullname"
                    placeholder="Enter your name"
                    class="md:border-0 lg:border-0"
                    name="Name"
                    :rules="{ required: true }"
                  ></base-input>
                </div>
                <div class="">
                  <p class="input-title">Email Address</p>
                  <base-input
                    v-model="userData.email"
                    placeholder="Enter your EmailID"
                    class="md:border-0 lg:border-0"
                    name="Email"
                    :rules="{ required: true }"
                  ></base-input>
                </div>
                <div class="">
                  <p class="input-title">Mobile No.</p>
                  <base-input
                    v-model="userData.mobile"
                    placeholder="Enter your Contact No."
                    class="md:border-0 lg:border-0"
                    name="Mobile No."
                    :rules="{ required: true }"
                  ></base-input>
                </div>
                <div class="">
                  <p class="input-title">City</p>
                  <base-input
                    v-model="location"
                    placeholder="Enter your City Name"
                    class="md:border-0 lg:border-0"
                    name="City"
                    :rules="{ required: true }"
                  ></base-input>
                </div>
                <div class="">
                  <p class="input-title">Comment</p>
                  <b-form-textarea
                    id="textarea"
                    v-model="description"
                    placeholder="Add Additional Comment"
                    rows="3"
                    max-rows="6"
                    class="scrollnone"
                    name="Description"
                    :state="description.length >= 1"
                  ></b-form-textarea>
                </div>
                <!-- :disabled="isValidForm" -->
                <div class="flex justify-center lg:px-12 md:px-4 px-2 mt-4 lg:mt-8">
                  <b-form-checkbox
                    id="checkbox-1"
                    value=" I have read and agreed to these"
                    unchecked-value="I have read and agreed to these"
                    v-model="status"
                  >
                    <p>
                      <strong
                        >{{ status }}
                        <u class="ublue" @click="editModal = true"
                          >terms and conditions</u
                        ></strong
                      >
                    </p></b-form-checkbox
                  >
                </div>
                <div class="flex justify-center px-12 mt-4 mt-8">
                  <b-button type="submit" :disabled="isdisabled" class="w-3/4"
                    >Submit</b-button
                  >
                </div>
              </div>
            </b-form>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import emailMixin from "@/mixins/email";

export default {
  data() {
    return {
      fullname: "",
      email: "",
      mobile: "",
      location: "",
      description: "",
      payload: {},
      status: "I have read and agreed to these",
      editModal: false,
    };
  },
  mixins: [emailMixin],

  methods: {
    async handleSend() {
      this.$store.dispatch("coach/getcoachform", {
        name: this.fullname,
        description: this.description,
        email: this.userData.email,
        mobile: this.userData.mobile,
        location: this.location,
      });
      const to = ["services@caregiversaathi.co.in"];

      const bcc = [
        "yash.singh@aiab.in",
        "bhavana.issar@caregiversaathi.co.in",
        "dona.mohapatra@caregiversaathi.co.in",
      ];

      const subject = "Caregiver Coach: Feedback";
      const message = `
      Name: ${this.fullname}<br />
      Email Address: ${this.userData.email}<br />
      Description: ${this.description}<br />
      Mobile No.: ${this.userData.mobile}<br />
      City: ${this.location}<br />
      `;
      await this.sendEmail(to, subject, message, bcc);
      this.$swal.fire({
        // title: "Created",
        text: "Thank you for submitting your details. We value your need. Allow our team 24-48 hours to get back to you.",
        icon: "success",
        confirmButtonColor: "#830c81",
        showCancelButton: false,
      });

      // this.$refs.formValidator.reset();
      // this.successAlert();
    },
  },
  mounted() {
    if (this.userData.firstname && this.userData.lastname) {
      this.fullname = this.userData.firstname + " " + this.userData.lastname;
    }
  },
  computed: {
    ...mapState("auth", ["userData"]),
    isdisabled() {
      if (this.status == "I have read and agreed to these") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
.ublue {
  color: rgb(86, 86, 248);
}
</style>
